import { useSelector } from 'react-redux';
import { useBetween } from 'use-between';
import { getTranslatedText as translate } from '../../../../Localization/Translation';

const DetailedRequest = () => {
    const { locale } = useBetween(useSelector(state => state.useSharedLang));
    var Details = {
        id: 1,
        name: 'مغسلة السعودية',
        date: '25/12/2020',
        phone: '0968820968',
        Address: 'عنوان الإقامة',
    }

    return (
        <div className='DetailedRequest-modal'>
            <div className='det-modal-info-row'>
                <span>
                    <i className="fa fa-building" aria-hidden="true"></i>
                    {translate('laundry-name', locale)}:
                </span>
                <span>{Details.name}</span>
            </div>
            <div className='det-modal-info-row'>
                <span>
                <i className="fa fa-calendar" aria-hidden="true"></i>
                    {translate('date-of-request', locale)}:
                </span>
                <span>{Details.date}</span>
            </div>
            <div className='det-modal-info-row'>
                <span>
                <i className="fa fa-phone" aria-hidden="true"></i>
                    {translate('phone-number', locale)}:
                </span>
                <span>{Details.phone}</span>
            </div>
            <div className='det-modal-info-row'>
                <span>
                <i className="fa fa-map-marker" aria-hidden="true"></i>
                    {translate('address', locale)}:
                </span>
                <span>{Details.Address}</span>
            </div>
        </div>
    )
}

export default DetailedRequest;